import { render } from "./AddDistributor.vue?vue&type=template&id=030486ae&scoped=true"
import script from "./AddDistributor.vue?vue&type=script&lang=js"
export * from "./AddDistributor.vue?vue&type=script&lang=js"

import "./AddDistributor.vue?vue&type=style&index=0&id=030486ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030486ae"]])

export default __exports__